import { resolveApiError } from '@crm/shared/api'

import { mapApiFieldErrors } from './map-api-field-errors'

import type { FieldPath, FieldValues, UseFormSetError } from 'react-hook-form'

type TFormApiErrorHandlerParams<TFormValues extends FieldValues> = {
  error: unknown
  fallback: string
  setError: UseFormSetError<TFormValues>
}

type TFormApiErrorHandlerConfig<TFormValues extends FieldValues> = {
  fieldByPointer: Readonly<Partial<Record<string, FieldPath<TFormValues>>>>
  showToast: (message: string) => void
}

export const createFormApiErrorHandler = <TFormValues extends FieldValues>({
  fieldByPointer,
  showToast,
}: TFormApiErrorHandlerConfig<TFormValues>) =>
  ({ error, fallback, setError }: TFormApiErrorHandlerParams<TFormValues>) => {
    const resolvedError = resolveApiError(error, fallback)

    if (resolvedError.type === 'toast') {
      showToast(resolvedError.message)
      return
    }

    const fieldErrors = mapApiFieldErrors(resolvedError.errors, fieldByPointer)

    if (!fieldErrors) {
      showToast(resolvedError.summary)
      return
    }

    fieldErrors.forEach(({ field, message }) => {
      setError(field, { type: 'server', message })
    })
  }
